import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemGoldenButton extends Item {
    constructor() {
        super(definitions.ITEM_ID.GOLDEN_BUTTON, texture("prop_gold_button_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(0, 0));
    }

    _playIdleAnimation() {
        this._view.animationSpeed = 10;
        this._view.gotoAndPlay("idle", true);
    }
}